// extracted by css-extract-rspack-plugin
export default {"cls1":"useOverviewReadyToast-cls1_5Xx","cls2":"useOverviewReadyToast-cls2_Ls6 useOverviewReadyToast-cls1_5Xx"};